<template>
  <div v-if="storeHabitacion.getAgrupacionesServicios.length > 0">
    <div>
      <CardPersonaReserva
        :numero-plazas="informacionGrupo.habitacion?.numPlazas"
        :idx-reserva="idxReserva"
        :agrupaciones-servicios="storeHabitacion.getAgrupacionesServiciosByReserva(reserva)"
        :has-modificar-persona="false"/>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import CardPersonaReserva from '@/modules/viajesGrupos/components/CardPersonaReserva.vue';

  const props = defineProps({
    informacionGrupo: {
      type: Object,
      default: null,
    },
    idxReserva: {
      type: Number,
      default: null,
    },
  });

  const storeHabitacion = informacionHabitacion();
  const reserva = computed(() => storeHabitacion.getReservaByIdx(props.idxReserva));
</script>

<style scoped>
  .form-check-input:checked {
    background-color: var(--bs-secondary);
    border-color: var(--bs-secondary);
  }

  .icon-inactive {
    transition: 0.3s;
  }

  .icon-active {
    transform: rotate(180deg);
    transition: 0.3s;
  }
</style>
